'use strict';

/*globals addRow*/
/*globals replaceAttrKey*/
/*globals initializeDateTimePicker*/
/*globals initializeRadio*/
/*globals initializeCheckbox*/

function removeInitializationPromo($wrapper) {
    $wrapper.find('.date-time-picker-init').removeClass('date-time-picker-init');
    $wrapper.find('.radio-custom').removeClass('radio-custom');
    $wrapper.find('.radio-custom-dummy').remove();
    $wrapper.find('.checkbox-custom').removeClass('checkbox-custom');
    $wrapper.find('.checkbox-custom-dummy').remove();
}

function initializePromo($wrapper) {
    initializeDateTimePicker($wrapper.find('[data-time-picker]'));
    initializeRadio($wrapper.find('input[type="radio"]'));
    initializeCheckbox($wrapper.find('input[type="checkbox"]'));
    $wrapper.find('.tac').tac();
    $wrapper.find('.clock-picker').each(function () {
        var $input = $(this);

        $input.inputmask({ alias: 'hh:mm' });
    });    
}

$(document).ready(function () {
    initializePromo($('body'));
});
